import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface RbacState {
    isLoading: boolean;
    error: string | null;
    extensions: any[];
  }
  
  const initialState: RbacState = {
    isLoading: false,
    error: null,
    extensions: [],
  };
  
  const rbacSlice = createSlice({
    name: "RBAC",
    initialState,
    reducers: {
      setIsLoading(state, action: any) {
        state.isLoading = action.payload;
      },
      setRbacData(state, action: PayloadAction<any[]>) {
        state.extensions = action.payload;
      },
      setRbacError(state, action: any) {
        state.error = action.payload;
      },
    },
  });
  
  export const { setIsLoading, setRbacData, setRbacError } = rbacSlice.actions;
  export default rbacSlice.reducer;
  